import axios from 'axios';
import {API_ROOT} from '../app/utils';
import {msgBar} from './msgBarActions';

export function fetchSuspiciousContactsDeletion() {
	return function(dispatch) {
		axios.get(API_ROOT + '/api/v1/suspicious-deletion', {withCredentials: true}).then((response) => {
			dispatch({
				type: "FETCH_SUSPICIOUS_CONTACTS_DELETION",
				payload: response.data
			})
		});
	}
}

export function putSuspiciousContactsDeletion(action) {
	return function(dispatch) {
		axios.put(API_ROOT + '/api/v1/suspicious-deletion', {
			"action": action
		}, {withCredentials: true}).then((response) => {
			//dispatch(msgBar(['success', response.data]));
			if(action === "approve"){
				dispatch(isConfirmApproveContactsDeletionShown(true))
			} else {
				dispatch(isConfirmRejectContactsDeletionShown(true))
			}
			dispatch(fetchSuspiciousContactsDeletion());
		}).catch((e) => {
			dispatch(msgBar(['error', e.response.data]));
		}).finally(() => {
			dispatch(isLoadingSuspiciousContactsDeletionAction(false));
		});
	}
}

export function isLoadingSuspiciousContactsDeletionAction(boolean) {
	return {
		type: "IS_LOADING_SUSPICIOUS_CONTACTS_DELETION_ACTION",
		payload: boolean
	}
}

export function isConfirmApproveContactsDeletionShown(boolean) {
	return {
		type: "IS_CONFIRM_APPROVE_CONTACTS_DELETION_SHOWN",
		payload: boolean
	}
}

export function isConfirmRejectContactsDeletionShown(boolean) {
	return {
		type: "IS_CONFIRM_REJECT_CONTACTS_DELETION_SHOWN",
		payload: boolean
	}
}

export function isContactsDeletionEnabled (boolean) {
	return {
		type: "IS_CONTACTS_DELETION_ENABLED",
		payload: boolean
	}
}

export function isContactsDeletionConfigLoading (boolean) {
	return {
		type: "IS_CONTACTS_DELETION_CONFIG_LOADING",
		payload: boolean
	}
}

export function putSuspiciousContactsDeletionConfig (object) {
	return function (dispatch) {
		axios.put(API_ROOT + '/api/v1/suspicious-deletion/configuration', object, {withCredentials: true}).then((response) => {
			dispatch(fetchSuspiciousContactsDeletion())
			dispatch(suspiciousContactsDeletionConfigToSend(response.data.deletionConfiguration))
		}).catch((e) => {
			dispatch(msgBar(['error', e.response.data]));
		}).finally(() => {
			setTimeout(() => {
				dispatch(isContactsDeletionConfigLoading(false));
			}, 500)
		});
	}
}

export function suspiciousContactsDeletionConfigToSend (object) {
	return {
		type: "SUSPICIOUS_CONTACTS_DELETION_CONFIG_TO_SEND",
		payload: object
	}
}
